import React from 'react';

import { times } from 'helpers';
import { Box } from 'UIKit';

import styles from './style.module.scss';

interface TopSectionSkeletonLoaderPropType {
  count: number;
}

const TopSectionSkeletonLoader = ({ count }: TopSectionSkeletonLoaderPropType) => {
  return (
    (<Box className={styles.cardSkeletonContainer} data-testid="topSectionSkeletonLoader">
      {times(count).map((_, idx) => (
        // eslint-disable-next-line react/no-array-index-key
        (<Box key={idx} className={styles.cardSkeleton} />)
      ))}
    </Box>)
  );
};

export default TopSectionSkeletonLoader;
